(function () {
  class FloatiesConfigurator extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-fyc-config]').textContent);
      this.stage = this.querySelector('[data-fyc-stage]');
      this.glasses = this.querySelector('[data-fyc-glasses]');
      this.layers = {
        temples: this.querySelector('[data-layer="temples"]'),
        lens: this.querySelector('[data-layer="lens"]'),
        frame: this.querySelector('[data-layer="frame"]'),
      };
      this.state = this.readUrl();
      this.surprise = this.readSurprise();
      this.addEventListener('change', (e) => {
        const input = e.target;
        if (!input.name || !input.name.startsWith('fyc-')) return;
        this.state[input.name.slice(4)] = input.value;
        this.fixLens(this.state);
        this.render();
      });
      this.querySelector('[data-fyc-random]').addEventListener('click', () => this.randomize());
      this.querySelector('[data-fyc-add]').addEventListener('click', () => this.addToCart());
      this.render();
      this.preloadAll();
    }

    readUrl() {
      const p = new URLSearchParams(window.location.search);
      const d = this.data;
      const pick = (key, list, fallback) => (list.some((o) => o.id === p.get(key)) ? p.get(key) : fallback);
      return this.fixLens({
        shape: pick('shape', d.shapes, d.defaults.shape),
        frame: pick('frame', d.colors, d.defaults.frame),
        temples: pick('temples', d.colors, d.defaults.temples),
        lens: pick('lens', d.lenses, d.defaults.lens),
      });
    }

    allowedLenses(shapeId) {
      const shape = this.find(this.data.shapes, shapeId);
      return (shape && shape.lenses) || this.data.lenses.map((l) => l.id);
    }

    fixLens(state) {
      const allowed = this.allowedLenses(state.shape);
      if (!allowed.includes(state.lens)) state.lens = allowed[0];
      return state;
    }

    find(list, id) {
      return list.find((o) => o.id === id);
    }

    tile(index, shape) {
      const col = index % 4;
      const row = Math.floor(index / 4);
      return {
        image: `url("${shape.sprite}")`,
        position: `${(col * 100) / 3}% ${(row * 100) / 4}%`,
      };
    }

    render() {
      const d = this.data;
      const s = this.state;
      const shape = this.find(d.shapes, s.shape);
      const frameI = d.colors.findIndex((c) => c.id === s.frame);
      const templesI = d.colors.findIndex((c) => c.id === s.temples);
      const lensI = d.lenses.findIndex((c) => c.id === s.lens);
      this.glasses.style.aspectRatio = shape.ratio;
      this.glasses.style.left = `${shape.box.left}%`;
      this.glasses.style.top = `${shape.box.top}%`;
      this.glasses.style.width = `${shape.box.width}%`;
      this.stage.style.backgroundColor = d.colors[frameI].bg;
      const allowed = this.allowedLenses(s.shape);
      this.querySelectorAll('input[name="fyc-lens"]').forEach((input) => {
        const off = !allowed.includes(input.value);
        input.disabled = off;
        input.closest('.fyc__sw').classList.toggle('is-disabled', off);
      });
      const note = this.querySelector('[data-fyc-lens-note]');
      if (note) note.hidden = allowed.length === d.lenses.length;
      const set = (el, idx) => {
        const t = this.tile(idx, shape);
        el.style.backgroundImage = t.image;
        el.style.backgroundPosition = t.position;
      };
      set(this.layers.temples, templesI);
      set(this.layers.frame, 8 + frameI);
      set(this.layers.lens, 16 + lensI);

      ['shape', 'frame', 'temples', 'lens'].forEach((k) => {
        const input = this.querySelector(`input[name="fyc-${k}"][value="${s[k]}"]`);
        if (input) input.checked = true;
      });
      const frame = d.colors[frameI];
      const temples = d.colors[templesI];
      const lens = d.lenses[lensI];
      this.querySelectorAll('[data-fyc-selected]').forEach((el) => {
        const k = el.dataset.fycSelected;
        el.textContent = { shape: shape.name, frame: frame.name, temples: temples.name, lens: lens.name }[k];
      });
      this.querySelector('[data-fyc-price]').textContent = shape.price;
      this.querySelector('[data-fyc-summary]').textContent =
        `${shape.name} · ${d.labels.frame}: ${frame.name} · ${d.labels.temples}: ${temples.name} · ${d.labels.lens}: ${lens.name}`;
      this.stage.setAttribute(
        'aria-label',
        `Floaties #YOU ${shape.name}, ${frame.name} frame, ${temples.name} temples, ${lens.name} lenses`
      );
      const url = new URL(window.location.href);
      Object.entries(s).forEach(([k, v]) => url.searchParams.set(k, v));
      window.history.replaceState({}, '', url);
    }

    readSurprise() {
      try { return JSON.parse(sessionStorage.getItem('fyc-surprise')) || { clicks: 0, last: '' }; } catch (e) { return { clicks: 0, last: '' }; }
    }

    code(s) {
      return `${s.shape}/${s.frame}/${s.temples}/${s.lens}`;
    }

    trackSurprise() {
      this.surprise.clicks += 1;
      this.surprise.last = this.code(this.state);
      try { sessionStorage.setItem('fyc-surprise', JSON.stringify(this.surprise)); } catch (e) {}
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('floaties_surprise_me', { clicks: this.surprise.clicks, combination: this.surprise.last });
        }
      } catch (e) {}
    }

    randomize() {
      const d = this.data;
      const r = (list) => list[Math.floor(Math.random() * list.length)].id;
      const lenses = this.allowedLenses(this.state.shape);
      this.state = {
        shape: this.state.shape,
        frame: r(d.colors),
        temples: r(d.colors),
        lens: lenses[Math.floor(Math.random() * lenses.length)],
      };
      this.render();
      this.trackSurprise();
    }

    preloadAll() {
      const load = () => this.data.shapes.forEach((sh) => { const i = new Image(); i.src = sh.sprite; });
      if ('requestIdleCallback' in window) window.requestIdleCallback(load);
      else setTimeout(load, 1500);
    }

    async addToCart() {
      const d = this.data;
      const s = this.state;
      const button = this.querySelector('[data-fyc-add]');
      const error = this.querySelector('[data-fyc-error]');
      const shape = this.find(d.shapes, s.shape);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = {
        items: [{
          id: shape.variant,
          quantity: 1,
          properties: {
            [d.labels.frame]: this.find(d.colors, s.frame).name,
            [d.labels.temples]: this.find(d.colors, s.temples).name,
            [d.labels.lens]: this.find(d.lenses, s.lens).name,
            _code: this.code(s),
          },
        }],
      };
      if (this.surprise.clicks > 0) {
        body.items[0].properties._surprise_clicks = String(this.surprise.clicks);
        body.items[0].properties._surprise_pick = this.surprise.last === this.code(s) ? 'yes' : 'no';
      }
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((sec) => sec.id);
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(button);
      }
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      error.hidden = true;
      try {
        const res = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'Error');
        if (cart && cart.renderContents && json.sections) {
          const item = json.items ? json.items[0] : json;
          item.sections = json.sections;
          cart.renderContents(item);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (e) {
        error.textContent = e.message;
        error.hidden = false;
      } finally {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
    }
  }
  if (!customElements.get('floaties-configurator')) customElements.define('floaties-configurator', FloatiesConfigurator);
})();
